import SysColumn from "app/class/sys-column";
import SysTable from "app/class/sys-table";

export const extractReferenceId = (value: unknown) => {
    if (typeof value === "string") {
        return value;
    }

    if (value && typeof value === "object" && "id" in value) {
        return String((value as Record<string, unknown>).id ?? "");
    }

    return "";
};

export const resolveDynamicReferenceTableName = ({
    column,
    columns,
    tables,
    dependencyValue,
}: {
    column: SysColumn;
    columns: SysColumn[];
    tables: SysTable[];
    dependencyValue: unknown;
}) => {
    if (column.column_type !== "DYNAMIC_REFERENCE" || !column.depends_on_column_id) {
        return column.referenced_table_name || "";
    }

    const dependencyColumn = columns.find((candidate) => candidate.id === column.depends_on_column_id);
    if (!dependencyColumn) {
        return "";
    }

    if (dependencyColumn.column_type === "REFERENCE" && dependencyColumn.referenced_table_name === "sys_tables") {
        const tableId = extractReferenceId(dependencyValue);
        return tables.find((table) => table.id === tableId)?.name || "";
    }

    if (dependencyValue && typeof dependencyValue === "object" && "name" in dependencyValue) {
        return String((dependencyValue as Record<string, unknown>).name ?? "");
    }

    return typeof dependencyValue === "string" ? dependencyValue : "";
};
